"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormattedConstantFilter = getFormattedConstantFilter;
exports.getQuery = void 0;
var _set2 = _interopRequireDefault(require("lodash/set"));
var _Condition = require("./CustomQueryForm/FilterForm/Condition");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var conditions = {};
var _loop = function _loop() {
  var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
    type = _Object$entries$_i[0],
    value = _Object$entries$_i[1];
  var list = {};
  value.forEach(function (item) {
    list[item.value] = item;
  });
  conditions[type] = list;
};
for (var _i = 0, _Object$entries = Object.entries(_Condition.allConditions); _i < _Object$entries.length; _i++) {
  _loop();
}
var getQuery = function getQuery(settings, prettify) {
  var obj = {};
  var variableRegex = /^variables\d+:/;
  var symbols = {
    '[': '***>>>',
    ']': '<<<***'
  };
  function encode(str) {
    for (var _i2 = 0, _Object$entries2 = Object.entries(symbols); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        key = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];
      str = str.split(key).join(value);
    }
    if (str.includes('{')) {
      str = str.split('.').join('<<**>>');
    }
    return str;
  }
  function decode(str) {
    for (var _i3 = 0, _Object$entries3 = Object.entries(symbols); _i3 < _Object$entries3.length; _i3++) {
      var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
        key = _Object$entries3$_i[0],
        value = _Object$entries3$_i[1];
      str = str.split(value).join(key);
    }
    str = str.split('<<**>>').join('.');
    return str;
  }
  function removeBrackets(str) {
    // remove all line breaks
    str = str.replace(/(\r\n|\n|\r)/gm, '');

    // keep the part inside quotes unchanged
    var strings = [];
    str = str.replace(/("[\w ]+")/g, function (_, string) {
      strings.push(string);
      return '#string#';
    });

    // keep the part inside parentheses unchanged
    var bodies = [];
    str = str.replace(/\(([^()]*)\)/g, function (_, body) {
      bodies.push(body);
      return '()';
    });
    var regex = /\{([^}]+)\}/g;
    while (regex.test(str)) {
      str = str.replace(regex, '.$1');
    }
    return str.replace(/\(\)/g, function () {
      return '(' + bodies.shift() + ')';
    }).replace(/\s+/g, '').replace(/#string#/g, function () {
      return strings.shift();
    });
  }

  // sort just to preserve query even if the column order has been changed
  var columns = _toConsumableArray(settings.columns).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });

  // Set variables
  (function () {
    var variablesColumns = columns.filter(function (column) {
      return variableRegex.test(column.query);
    });
    var sections = {};
    var _iterator = _createForOfIteratorHelper(variablesColumns),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var column = _step.value;
        var _column$query$split = column.query.split('.variables.'),
          _column$query$split2 = _slicedToArray(_column$query$split, 2),
          left = _column$query$split2[0],
          right = _column$query$split2[1];
        sections[left] = sections[left] || [];
        sections[left].push("\"".concat(right, "\""));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    for (var _i4 = 0, _Object$entries4 = Object.entries(sections); _i4 < _Object$entries4.length; _i4++) {
      var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i4], 2),
        name = _Object$entries4$_i[0],
        variables = _Object$entries4$_i[1];
      (0, _set2["default"])(obj, removeBrackets("".concat(name, ".variables(name: ***>>>").concat(variables.join(','), "<<<***)")));
    }
  })();

  // Set other fields
  (function () {
    var otherColumns = columns.filter(function (column) {
      return !column.isAction && !variableRegex.test(column.query);
    });
    var _iterator2 = _createForOfIteratorHelper(otherColumns),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var column = _step2.value;
        var path = encode(column.query || column.name);
        (0, _set2["default"])(obj, removeBrackets(path));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  })();

  // Set key field
  (0, _set2["default"])(obj, 'pawn.pawnId');
  function getFields(node) {
    var str = '';
    for (var _i5 = 0, _Object$entries5 = Object.entries(node); _i5 < _Object$entries5.length; _i5++) {
      var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i5], 2),
        key = _Object$entries5$_i[0],
        value = _Object$entries5$_i[1];
      if (!value) {
        str += ' ' + key;
      } else {
        str += ' ' + key + ' { ' + getFields(value) + ' }';
      }
    }
    return str;
  }

  // Get filter
  var constantFilter = getFormattedConstantFilter(settings.filter);
  var filter = constantFilter ? "{\n            AND: [\n                ".concat(constantFilter, "\n                $filter\n            ]\n        }") : '$filter';

  // let condition = '';
  //     if (settings.projectId) {
  //         if (settings.hasIdentifiable) {
  //             condition += `\nandHasAll: [{ permission: "quest.view_identifiable_data", groupId: ${settings.projectId} }]`;
  //         }
  //
  //         condition += `\nandHasAny: [
  //     { permission: "quest.tables", groupId: ${settings.projectId} }
  //     { permission: "quest.admin", groupId: ${settings.projectId} }
  // ]`;
  //     }

  var query = decode("query($deploymentId: [Int]!, $projectId: [Int]!, $limit: Int, $offset: Int, $orderBy: [OrderBy], $filter: Filter, $metrics: [String]) {\n        flows(\n            as: ANY\n            ".concat(settings.includeIdentifiable ? 'andHasAll: [{ permission: "quest.view_identifiable_data", groupId: $projectId }]' : '', "\n            andHasAny: [\n                { permission: \"quest.view_data\", groupId: $projectId }\n                { permission: \"quest.admin\", groupId: $projectId }\n            ]\n        ) {\n            assignmentProgressList(deploymentId: $deploymentId, limit: $limit, offset: $offset, orderBy: $orderBy, filter: ").concat(filter, ") {\n                assignmentProgressId\n                language\n                surveylist {\n                    surveylistHandle\n                }\n                deployment(includeAllRelated: true) {\n                    label\n                    timepoint\n                }\n                pawn(context: GLOBAL) {\n                    ").concat(getFields(obj), "\n                }\n                variables(codedValues: ").concat(settings.codedValues, ", includeIdentifiable: ").concat(settings.includeIdentifiable, ", name: $metrics)\n            }\n            totalCount: assignmentProgressCount(deploymentId: $deploymentId ").concat(constantFilter ? ", filter: ".concat(constantFilter) : '', ")\n            filteredCount: assignmentProgressCount(deploymentId: $deploymentId, filter: ").concat(filter, ")\n        }\n    }"));
  return prettify ? prettify(query) : query;
};
exports.getQuery = getQuery;
function getFormattedConstantFilter(filter) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'str';
  // "format" can be one of "str" or "obj"
  function traverse(node) {
    if (!node) {
      return format === 'obj' ? {} : '';
    }
    var hasConditions = node.aggregation && node.conditions.filter(function (item) {
      return item.column;
    }).length > 0;
    if (node.aggregation === 'all' && hasConditions) {
      return format === 'obj' ? {
        AND: node.conditions.map(traverse)
      } : "{ AND: [ ".concat(node.conditions.map(traverse).join(' '), " ] }");
    }
    if (node.aggregation === 'any' && hasConditions) {
      return format === 'obj' ? {
        OR: node.conditions.map(traverse)
      } : "{ OR: [ ".concat(node.conditions.map(traverse).join(' '), " ] }");
    }
    if (node.column) {
      return format === 'obj' ? _defineProperty({}, node.operator, {
        field: "pawn.".concat(node.column.id),
        "int": node.column.type === 'number' ? node.value : undefined,
        string: node.column.type === 'string' ? node.value : undefined,
        "boolean": node.column.type === 'boolean' ? node.value : undefined
      }) : '{ ' + conditions[node.column.type][node.operator].getCondition({
        field: 'pawn.' + node.column.id,
        value: node.value
      }) + ' }';
    }
    return '';
  }
  return traverse(filter);
}